module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOTHER’S DAY SALE THIS WEEK ON ALL THESE BOOKS! | The Master Chefs Series and World")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Romances from Kailin Gow | THE LOVING SUMMER SERIES")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE NEVER KNIGHTS SERIES")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SESSIONS: SEX SHRINK OF SEATTLE SERIAL")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FILTHY DIRTY LAUNDRY SERIAL")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Short, Sassy, and Sexy Romantic Comedy Reads from Kailin Gow’s Pen Names")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fantasy Romance Books from Kailin Gow")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookbooks, Lifestyle and Self-Help Books from Kailin Gow | The Perfect Cup:  Tea | Kailin Gow's Go Girl Guide to SUPERFOODS (Kailin Gow's Go Girl Guides Book 1) | Kailin Gow’s Go Girl Guide to Going for It (Kailin Gow’s Go Girl Guides)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raising A Strong Daughter: What Fathers Should Know")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get a FREE AUDIOBOOK Copy of Kailin Gow’s Go Girl Guide to Superfoods Audiobook when it Releases in May 2018 and get notified of Kailin’s New Releases, Contests, Promos, and More! | https://www.subscribepage.com/g9r7j6")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0